

































































































// TODO: Address this tech debt by adding proper type checking
// @ts-nocheck
import { Component, Vue, Prop } from 'vue-property-decorator'
import { requiredIf, minLength } from 'vuelidate/lib/validators'
import { Getter, Mutation } from 'vuex-class'

import FormPhoneNumber from '@/components/form/form-phone-number.vue'
import { customerInfoService } from '../../services/customer-info.service'
import { CustomerInfoInterface } from '../../interfaces/customer-info.interface'

const fieldRequired = (value) => {
  return value !== undefined
}

let validations: any = {
  customerInfo: {
    StreetAddressNewValue: {
      required: requiredIf((v) => {
        return !v.StreetAddressRequired || (v.StreetAddressRequired && !!v.StreetAddress)
          ? false
          : !v.StreetAddressNewValue
      }),
    },
    StreetAddress2NewValue: {
      required: requiredIf((v) => {
        return !v.StreetAddress2Required || (v.StreetAddress2Required && !!v.StreetAddress2)
          ? false
          : !v.StreetAddress2NewValue
      }),
    },
    ZipPostalCodeNewValue: {
      required: requiredIf((v) => {
        return !v.ZipPostalCodeRequired || (v.ZipPostalCodeRequired && !!v.ZipPostalCode)
          ? false
          : !v.ZipPostalCodeNewValue
      }),
      minLength: minLength(4),
    },
    PhoneNewValue: {
      required: requiredIf((v) => {
        return !v.PhoneRequired || (v.PhoneRequired && !!v.Phone) ? false : !v.PhoneNewValue
      }),
    },
  },
}

@Component({
  components: {
    FormPhoneNumber,
  },
  validations: validations,
})
export default class MissingCustomerInfo extends Vue {
  @Prop({ default: 'Customer Info' }) title: string
  @Prop({ default: 'Please provide the following customer info' }) description: string
  @Getter('global/labels') labels
  @Mutation('updateRouteCondition') updateRouteCondition
  @Mutation('removeRouteCondition') removeRouteCondition

  // SECTION Data
  private apiLoading = false
  private apiSaving = false
  private customerInfo: any | null = null
  private apiError: any = {}
  private saveCustomerInfoResult: any | null = null
  private routeConditionKey = `missing-customer-info`
  private needsCustomerInfo = false

  $v: any

  // !SECTION Data

  // SECTION Lifecycle Hooks
  mounted() {
    this.updateRouteCondition({ routeName: 'confirm', conditionKey: this.routeConditionKey })

    if (!this.customerInfo) {
      this.getCustomerInfo()
    }

    window.addEventListener('checkout:step:confirm', (e) => {
      if (this.needsCustomerInfo) {
        this.saveCustomerInfo()
      }
    })
  }
  // SECTION !Lifecycle Hooks

  // SECTION Computed
  get hasMissingCustomerInfo(): boolean {
    if (this.customerInfo) {
      return (
        this.missingCustomerInfo('StreetAddress') ||
        this.missingCustomerInfo('StreetAddress2') ||
        this.missingCustomerInfo('ZipPostalCode') ||
        this.missingCustomerInfo('Phone')
      )
    }

    return false
  }

  get newCustomerInfo(): CustomerInfoInterface {
    if (this.customerInfo) {
      const newInfo = {
        ...this.customerInfo,
      }
      Object.keys(newInfo).forEach((k) => {
        if (k.includes('NewValue')) {
          const fieldKey = k.replace('NewValue', '')
          newInfo[fieldKey] = newInfo[k]
          delete newInfo[k]
        }
      })

      return newInfo
    }

    return {}
  }
  // !SECTION Computed

  // SECTION Methods
  async getCustomerInfo(): Promise<void> {
    this.apiLoading = true
    const loadingCondition = {
      key: this.routeConditionKey,
      complete: false,
      error: false,
      loading: true,
    }
    this.updateRouteCondition({
      routeName: 'confirm',
      conditionKey: this.routeConditionKey,
      conditionValues: loadingCondition,
    })
    window.dispatchEvent(new Event('route:condition:updated'))
    this.customerInfo = null
    try {
      const customerInfo = await customerInfoService.getCustomerInfo()
      this.customerInfo = customerInfo
      window.dispatchEvent(new Event('route:condition:updated'))
      this.needsCustomerInfo = this.hasMissingCustomerInfo
      if (this.customerInfo.ZipPostalCodeRequired) {
        this.customerInfo = {
          ...this.customerInfo,
          ZipPostalCodeNewValue: '',
        }
      }
      if (!this.needsCustomerInfo) {
        const completeCondition = {
          key: this.routeConditionKey,
          complete: true,
          error: false,
          loading: false,
        }
        this.removeRouteCondition({
          routeName: 'confirm',
          conditionKey: this.routeConditionKey,
        })
      } else {
        const incompleteCondition = {
          key: this.routeConditionKey,
          complete: false,
          error: false,
          loading: false,
        }
        this.updateRouteCondition({
          routeName: 'confirm',
          conditionKey: this.routeConditionKey,
          conditionValues: incompleteCondition,
        })
        window.dispatchEvent(new Event('route:condition:updated'))
      }
    } catch (err) {
      this.apiError = err
      const errorCondition = {
        key: this.routeConditionKey,
        complete: false,
        error: true,
        loading: false,
      }
      this.updateRouteCondition({
        routeName: 'confirm',
        conditionKey: this.routeConditionKey,
        conditionValues: errorCondition,
      })
      window.dispatchEvent(new Event('route:condition:updated'))
    } finally {
      this.apiLoading = false
    }
  }

  missingCustomerInfo(field: string) {
    const fieldEnabledProperty = `${field}Enabled`
    const fieldRequiredProperty = `${field}Required`
    const fieldProperty = `${field}`

    const fieldEnabled = this.customerInfo[fieldEnabledProperty]
    const fieldRequired = this.customerInfo[fieldRequiredProperty]
    const fieldValue = this.customerInfo[fieldProperty]

    if (fieldEnabled !== undefined && fieldRequired !== undefined && fieldValue !== undefined) {
      return fieldEnabled && fieldRequired && !fieldValue
    }

    return false
  }

  async saveCustomerInfo() {
    this.$v.$touch()

    if (!this.$v.$error) {
      this.apiSaving = true
      const loadingCondition = {
        key: this.routeConditionKey,
        complete: false,
        error: false,
        loading: true,
      }
      this.updateRouteCondition({
        routeName: 'confirm',
        conditionKey: this.routeConditionKey,
        conditionValues: loadingCondition,
      })
      window.dispatchEvent(new Event('route:condition:updated'))
      try {
        this.saveCustomerInfoResult = await customerInfoService.postCustomerInfo(this.newCustomerInfo)
        const savedCondition = {
          key: this.routeConditionKey,
          complete: true,
          error: false,
          loading: false,
        }
        this.updateRouteCondition({
          routeName: 'confirm',
          conditionKey: this.routeConditionKey,
          conditionValues: savedCondition,
        })
        window.dispatchEvent(new CustomEvent('route:condition:updated', savedCondition))
        this.needsCustomerInfo = this.hasMissingCustomerInfo
      } catch (err) {
        this.apiError = err
        const errorCondition = {
          key: this.routeConditionKey,
          complete: false,
          error: true,
          loading: false,
        }
        this.updateRouteCondition({
          routeName: 'confirm',
          conditionKey: this.routeConditionKey,
          conditionValues: errorCondition,
        })
        window.dispatchEvent(new CustomEvent('route:condition:updated', errorCondition))
      } finally {
        this.apiSaving = false
      }
    } else {
      const errorCondition = {
        key: this.routeConditionKey,
        complete: false,
        error: true,
        loading: false,
      }
      this.updateRouteCondition({
        routeName: 'confirm',
        conditionKey: this.routeConditionKey,
        conditionValues: errorCondition,
      })
      window.dispatchEvent(new CustomEvent('route:condition:updated', errorCondition))
    }
  }
  // !SECTION Methods
}
